'use client';

import HeaderSkeleton from '@carvana/header';
import { commonEnvironment } from '~/constants/environment';

type OwnProps = {
  route: string;
};

// The composer-treatment header an SPA navigation lands on, matching ClientPageHeader's props for that route.
export default function ComposerHeaderSkeleton({ route }: OwnProps) {
  return (
    <HeaderSkeleton
      cookies={{}}
      environment={commonEnvironment}
      route={route}
      shouldLoadPlugin={false}
      showChatUi={false}
      showComposerTreatment
      useProvider={false}
    />
  );
}
